import { render, staticRenderFns } from "./TransferenciaPreparo.vue?vue&type=template&id=89d0cff8&"
import script from "./TransferenciaPreparo.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPreparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports